import { render, staticRenderFns } from "./JDDirectInvestmentLayout.vue?vue&type=template&id=c903a25c&scoped=true&"
import script from "./JDDirectInvestmentLayout.vue?vue&type=script&lang=js&"
export * from "./JDDirectInvestmentLayout.vue?vue&type=script&lang=js&"
import style0 from "./JDDirectInvestmentLayout.vue?vue&type=style&index=0&id=c903a25c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c903a25c",
  null
  
)

export default component.exports